import apiClient, { unwrap } from './client'
import type { AuditLog } from './types'

export const auditLogsApi = {
  list(limit = 100) {
    return unwrap<AuditLog[]>(
      apiClient.get('/audit-logs', { params: { limit } }),
    )
  },
}
